import Vue from 'vue'
import VueRouter from 'vue-router'
import http from 'axios'
import store from './store'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/infobits'
    },
    {
      path: '/login',
      component: require('./components/login-page.vue')
    },
    {
      path: '/infobits',
      component: require('./components/infobits-app.vue'),
      beforeEnter: (to, from, next) => http.get('/accesscontrol/user')
        .then(response => {
          const username = response.data
          if (username) {
            console.log('Router(/infobits): logged in', username)
            setWorkspaceCookie()
          } else {
            console.log('Router(/infobits): not logged in')
          }
          store.dispatch('initStore', username)
          next()
        })
        .catch(error => console.log('Error while checking logged in user', error))
    }
  ]
})

function setWorkspaceCookie () {
  http.get('/infobits/workspace').then(response => {
    const workspaceId = response.data.id
    document.cookie = 'dm4_workspace_id=' + workspaceId + ';path=/'
  })
}



// WEBPACK FOOTER //
// ./src/router.js